import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AddEducationLevels, EducationLevels } from '../models/educationLevels/educationLevels';



@Injectable({
  providedIn: 'root'
})
export class EducationLevelsService {

  constructor(
    private _http: HttpClient
  ) { }

    public getEducationLevels(EducationLevelsId?: number): Observable<EducationLevels[]>{
        return this._http.get<EducationLevels[]>(`${environment.api.url}/EducationLevels?EducationLevelsId=${EducationLevelsId??''}`);
    }
  
    public deleteEducationLevels(EducationLevelsId: number): Observable<boolean> {
        return this._http.delete<any>(`${environment.api.url}/EducationLevels/${EducationLevelsId}`);
    }
  
    public addEducationLevels(model: AddEducationLevels): Observable<boolean> {
        return this._http.post<any>(`${environment.api.url}/EducationLevels`, model);
    }
}
